import decimalField from "../../common/decimal-field.vue";
import dateField from "@/components/common/date-field";
import { hasValue } from "../../../utils/functions.js";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
    name: "Parameters",

    components: {
        decimalField,
        dateField,
        VueTypeaheadBootstrap
    },

    ListParameters: [],

    data: function () {
        return {
            modalTitle: "Novo Parâmetro",
            labelName: "Nome",
            Parameters: [],
            disabled: 0,
            countFilter: 0,
            idParameters: 0,
            selected_Parameters: [],
            parameters_list: [],
            selectedType: null,
            infoParameters: {
                Id: null,
                Reference: null,
                Name: null,
                Value: null,
                TypeDescription: null,
                Type: null
            },
            countFilter: 0,
            filter: {
                Reference: null,
                Name: null
            },
            searchNewParameter: {
                Reference: null,
                Name: null
            },
            types: [
                {
                    value: "percentage",
                    label: "Porcentagem"
                },
                {
                    value: "date",
                    label: "Data"
                },
                {
                    value: "value",
                    label: "Valor"
                },
                {
                    value: "number",
                    label: "Número"
                },
                {
                    value: "text",
                    label: "Texto"
                },
                {
                    value: "html",
                    label: "HTML"
                },
                {
                    value: "boolean",
                    label: "Boleano"
                }
            ],
            referenceOptions: [],
            isNewParameter: false,
            isDisableName: false,
            isDisable: false,
            disableModalButton: false,
            loadingAddUpdate: false,
            loadingList: false,
            loadingModal: false,
            loadingReport: false,
            validatedParameterForm: false,
            isSeeing: false,
            pOpened: null,
            pagination: {
                PageNumber: 1,
                RowsPerPage: 10
            },
            window: {
                width: 0,
                height: 0,
            }
        };
    },

    computed: {},

    watch: {
        "pagination.PageNumber": function () {
            this.ListParameter();
        },
        "pagination.RowsPerPage": function () {
            this.ListParameter();
        },
    },

    mounted() {
        this.ListParameter();
    },

    methods: {
        OpenParameters: function (e, index) {
            e.preventDefault();
            this.validatedParameterForm = false;
            this.loadingAddUpdate = false;
            this.ResetInfoParameter();
            this.disableModalButton = false;

            if (index == undefined) {
                this.isDisableName = true;
                this.referenceOptions = [];
                this.disableModalButton = true;
                this.modalTitle = "Novo Parâmetro";
                this.pOpened = null;
                this.isDisable = false;
                this.isNewParameter = true;
            } else {
                this.modalTitle = "Editar Parâmetro";
                this.pOpened = index;
                this.isDisable = true;
                this.isNewParameter = false;
                this.GetParameters(this.Parameters[index]);
            }
            this.$bvModal.show("mFormParameters");
        },

        GetParameters: function (parameter) {
            this.loadingModal = true;
            this.infoParameters = {
                Id: parameter.Id,
                Reference: parameter.Reference,
                Name: parameter.Name,
                Value: (parameter.TypeDescription == "value" || parameter.TypeDescription == "percentage") ? Number(parameter.Value) : parameter.Value,
                TypeDescription: parameter.TypeDescription,
                Type: (parameter.TypeDescription == "percentage") ? parameter.Type.toString() : parameter.Type
            }
            this.loadingModal = false;
        },

        ResetInfoParameter: function () {
            this.selected_Parameters = null;
            this.infoParameters = {
                Id: null,
                Reference: "",
                Name: "",
                Value: null,
                Type: null
            };
        },

        ListParameter: function () {
            this.loadingList = true;
            this.countFilter = 0;
            this.ResetInfoParameter();

            this.countFilter = 0;
            if (hasValue(this.filter.Reference)) this.countFilter++;
            if (hasValue(this.filter.Name)) this.countFilter++;

            let data = {
                ...this.pagination,
                "Object.Id": this.infoParameters.Id,
                "Object.Reference": (hasValue(this.filter.Reference)) ? this.filter.Reference : this.infoParameters.Reference,
                "Object.Name": (hasValue(this.filter.Name)) ? this.filter.Name : this.infoParameters.Name,
                "Object.Value": this.infoParameters.Value,
                "Object.Type": this.infoParameters.Type,
            };
            delete data.TotalItems;
            this.$store
                .dispatch("ListParameters", { params: data })
                .then((response) => {
                    this.Parameters = response.Objects;
                    this.pagination.TotalItems = response.TotalItems;
                    for (let i = 0; i < this.Parameters.length; i++) {
                        if (this.Parameters[i].Type == 1) {
                            this.Parameters[i].TypeDescription = "percentage";
                        } else if (this.Parameters[i].Type == 2) {
                            this.Parameters[i].TypeDescription = "date";
                        } else if (this.Parameters[i].Type == 3) {
                            this.Parameters[i].TypeDescription = "value";
                        } else if (this.Parameters[i].Type == 4) {
                            this.Parameters[i].TypeDescription = "number";
                        } else if (this.Parameters[i].Type == 6) {
                            this.Parameters[i].TypeDescription = "html";
                        } else if (this.Parameters[i].Type == 7) {
                            this.Parameters[i].TypeDescription = "boolean";
                        } else {
                            this.Parameters[i].TypeDescription = "text";
                        }
                    }
                })
                .catch((error) => {
                    this.$makeToast(
                        "Um erro ocorreu ao listar os campos. Tente novamente.",
                        "danger",
                        "Erro ao listar os Campos",
                        error
                    );
                })
                .finally(() => (this.loadingList = false));
        },

        SaveParameter: function () {
            this.validatedParameterForm = true;
            this.$refs.ParameterValidationForm.validate().then((isValid) => {
                if (isValid) {
                    this.loadingAddUpdate = true;
                    this.isSeeing = true;

                    if (this.infoParameters.TypeDescription == "percentage") {
                        this.infoParameters.IdType = 1;
                    } else if (this.infoParameters.TypeDescription == "date") {
                        this.infoParameters.IdType = 2;
                    } else if (this.infoParameters.TypeDescription == "value") {
                        this.infoParameters.IdType = 3;
                    } else if (this.infoParameters.TypeDescription == "number") {
                        this.infoParameters.IdType = 4;
                    } else if (this.infoParameters.TypeDescription == "text") {
                        this.infoParameters.IdType = 5;
                    } else if (this.infoParameters.TypeDescription == "html") {
                        this.infoParameters.IdType = 6;
                    }

                    if (this.pOpened == null) {
                        this.$store
                            .dispatch("AddParameters", {
                                Reference: this.infoParameters.Reference,
                                Name: this.infoParameters.Name,
                                Value: this.infoParameters.Value != null ? this.infoParameters.Value : "",
                                IdType: this.infoParameters.IdType,
                                Type: this.infoParameters.TypeDescription != null ? this.infoParameters.TypeDescription : "",
                            })
                            .then(() => {
                                this.$makeToast("Parâmetro cadastrado com sucesso", "success", "Cadastro");
                                this.$bvModal.hide("mFormParameters");
                                this.ListParameter();
                            })
                            .catch((error) => {
                                this.$makeToast(undefined, "danger", "Erro ao cadastrar categoria", error);
                            })
                            .finally(() => {
                                this.loadingAddUpdate = false;
                                this.isSeeing = false;
                            });
                    } else {
                        this.$store
                            .dispatch("UpdateParameters", {
                                Id: this.infoParameters.Id,
                                Reference: this.infoParameters.Reference,
                                Name: this.infoParameters.Name,
                                Value: this.infoParameters.Value,
                                IdType: this.infoParameters.IdType,
                                Type: this.infoParameters.Type
                            })
                            .then(() => {
                                this.$makeToast("O parâmetro foi atualizado com sucesso.", "success", "Atualizado");
                                this.ListParameter();
                                this.$bvModal.hide("mFormParameters");
                            })
                            .catch((error) => {
                                this.$makeToast(undefined, "danger", "Erro ao atualizar categoria", error);
                            })
                            .finally(() => {
                                this.loadingAddUpdate = false;
                                this.isSeeing = false;
                            });

                    }
                }
            });
        },

        OpenModalFilter: function () {
            this.$bvModal.show("mFilter");
        },

        ResetFilter: function () {
            this.filter = {
                Reference: null,
                Name: null
            };
            this.ListParameter();
        },

        Filter: function () {
            this.$bvModal.hide("mFilter");
            this.ListParameter();
        },

        searchExistingParameterReference: function (reference) {
            let data = {
                "Object.Reference": reference,
                "Object.Name": ""
            };
            this.$store
                .dispatch("FindParameters", { params: data })
                .then((response) => {
                    let tempReferenceOptions = [];
                    for (let i = 0; i < response.Objects.length; i++) {
                        tempReferenceOptions[i] = response.Objects[i].Reference;
                    }
                    this.referenceOptions = tempReferenceOptions.filter(function (el, i) {
                        return tempReferenceOptions.indexOf(el) === i;
                    });
                })
                .catch((error) => {
                    this.$makeToast(
                        "Um erro ocorreu ao listar o campo referência. Tente novamente.",
                        "danger",
                        "Erro ao listar o campo referência",
                        error
                    );
                }).finally(() => {
                    this.isDisableName = false;
                });
        },

        SearchReferenceWhenStop: function SearchReferenceWhenStop($event) {
            if (this.isNewParameter) {
                clearTimeout(SearchReferenceWhenStop.timeout);
                this.searchNewParameter.Reference = $event;

                if (this.searchNewParameter.Reference.length >= 3) {
                    SearchReferenceWhenStop.timeout = setTimeout(function (searchNewParameter, searchExistingParameterReference) {
                        searchExistingParameterReference(searchNewParameter.Reference);
                    }, 300, this.searchNewParameter, this.searchExistingParameterReference);
                } else {
                    this.disableModalButton = true;
                    this.isDisableName = true;
                    this.infoParameters.Name = "";
                }
            }
        },

        searchExistingParameterName: function (data) {
            if (data["Object.Name"].length >= 3) {
                this.$store
                    .dispatch("FindParameters", { params: data })
                    .then((response) => {
                        if (response.Objects.length > 0) {
                            this.$makeToast("Parâmetro já cadastrado!", "danger", "Erro");
                            this.infoParameters.Name = null;
                            this.disableModalButton = true;
                        } else {
                            this.disableModalButton = false;
                        }
                    })
                    .catch((error) => {
                        this.$makeToast(
                            "Um erro ocorreu ao listar o campo parâmetro. Tente novamente.",
                            "danger",
                            "Erro ao listar o campo parâmetro",
                            error
                        );
                        this.disableModalButton = true;
                    }).finally(() => {
                        this.isDisableName = false;
                    });
            } else {
                this.disableModalButton = true;
            }
        },

        SearchNameWhenStop: function SearchNameWhenStop($event) {
            if (this.isNewParameter) {
                clearTimeout(SearchNameWhenStop.timeout);
                this.searchNewParameter.Name = $event;

                if (this.searchNewParameter.Name != null) {
                    SearchNameWhenStop.timeout = setTimeout(function (searchNewParameter, searchExistingParameterName) {
                        let data = {
                            "Object.Reference": searchNewParameter.Reference,
                            "Object.Name": searchNewParameter.Name
                        };
                        searchExistingParameterName(data);
                    }, 300, this.searchNewParameter, this.searchExistingParameterName);
                }
            }
        },
        ResetValue: function () {
            this.infoParameters.Value = null
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/pages/Parameters/Parameters.js